import { render, staticRenderFns } from "./DownloadsDetails.vue?vue&type=template&id=76de6da6&scoped=true"
import script from "./DownloadsDetails.vue?vue&type=script&lang=js"
export * from "./DownloadsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76de6da6",
  null
  
)

export default component.exports